import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureReposDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M34 7.99314V27.4491L26 34L13.6 29.4857V33.9611L6.58057 24.7886L27.04 26.3886V8.86857L34 7.99314ZM27.1794 8.97143L15.7006 2V6.57371L5.15886 9.67086L2 13.7257V22.9349L6.52114 24.9303V13.1291L27.1794 8.97143Z",
		fill: "#262626"
	})]
});
const ForwardRef = forwardRef(SvgAzureReposDark);
export { ForwardRef as ReactComponent };
